module.exports = __webpack_public_path__ + "img/Recubre_Aparentador Gris.b0b751ef.png";